export default function capitalizeFirstLetter<T extends string>(
  string?: T
): Capitalize<T> {
  return string
    ? ((string.charAt(0).toUpperCase() + string.slice(1)) as Capitalize<T>)
    : ('' as Capitalize<T>)
}
